import { formatDateTime } from '../../shared/utility/dateFormatter';

// Contextual per-row summary, matching the reference portal's "Details" column: what happened
// to this item most recently (disposed / checked out / last transaction).
export const getRowDetails = (item) => {
  const disposition = Array.isArray(item.EvidenceDisposition)
    ? item.EvidenceDisposition[0]
    : item.EvidenceDisposition;

  if (disposition?.IsDisposed) {
    return `Disposed: ${disposition.FinalDisposition || '—'} on ${formatDateTime(
      disposition.DispositionDate
    )}`;
  }

  const custody = Array.isArray(item.EvidenceCustody) ? item.EvidenceCustody : [];
  const lastCustody = [...custody].sort(
    (a, b) => new Date(b.TransactionDate) - new Date(a.TransactionDate)
  )[0];

  if (!lastCustody) return '—';

  if (item.Status === 'Out' && lastCustody.CustodyTo) {
    return `Checked out to: ${lastCustody.CustodyTo} on ${formatDateTime(
      lastCustody.TransactionDate
    )}`;
  }

  return `${lastCustody.TransactionType || ''} — ${formatDateTime(lastCustody.TransactionDate)}`;
};
